// import stuReport from '@/views/studyReportwx/stuReport'
const stuReport = () => import('@/views/studyReportwx/stuReport')
// import chapterReport from '@/views/studyReportwx/chapterReport'
const chapterReport = () => import('@/views/studyReportwx/chapterReport')

export default [
    {
        path: '',
        component: stuReport,
        meta: {
            title: '学情报告'
        }
    },
    {
        path: '/stureportwx/:sectionCode',
        component: chapterReport,
        meta: {
            title: '学情报告'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/stureportwx.js